import React, { useEffect, useState } from 'react';
import Layout from '../components/Layout';
import classes from "./SubscriptionPage.module.css";
import { useTranslation } from 'react-i18next';
import Header from '../components/Header';
import SmallLoader from '../components/Loaders/SmallLoader';
import OTPInput from "react-otp-input";
import { useNavigate, useSearchParams } from 'react-router-dom';
import { FaCheck } from "react-icons/fa";
// import { getPacks } from '../http/http';
import { useDispatch, useSelector } from 'react-redux';
// import { SendOtpAPI } from '../http/http';
import { setUserToken } from '../store/slices/userTokenSlice';
import { toast } from 'react-toastify';
import { v4 as uuidv4 } from 'uuid';
import TermsModal from '../components/TermsModal';
import AutoRenewalModal from '../components/AutoRenewalModal';
import { login } from '../http/http';

const SubscriptionPage2 = () => {
    const { t } = useTranslation();
    const [msisdn, setMsisdn] = useState("");
    const [extRef, setExtRef] = useState(null);
    const [termsModal, setTermsModal] = useState(false);
    const [searchParams, setSearchParams] = useSearchParams();

    const [autoRenew, setAutoRenew] = useState(true);
    const [terms, setTerms] = useState(false);

    const [pack, setPack] = useState("Daily");

    const [loading, setLoading] = useState(false);

    const navigate = useNavigate();
    const dispatch = useDispatch();

    const { userToken } = useSelector(state => state.persisted.userTokenSlice);

    const [autoRenewal, setAutoRenewal] = useState(false);

    useEffect(() => {
        if (userToken) {
            navigate("/home");
        }
    }, [userToken]);

    useEffect(() => {
        if (searchParams.get("ext_id")) {
            setExtRef(searchParams.get("ext_id"));
        } else {
            setSearchParams({ ext_id: uuidv4().substring(0, 25) });
        }
    }, [searchParams]);

    const handleSubscribe = async (e) => {
        e.preventDefault();

        if (msisdn?.trim().length == 0) {
            return;
        }

        if (!terms) {
            toast.error(t("145"));
            return;
        }

        await login({ msisdn: msisdn })
            .then((res) => {
                setLoading(false);
                dispatch(setUserToken(res?.data?.result?.token));
                navigate("/home");
                toast.success(t("84"));
            })
            .catch((err) => {
                setLoading(false);
                if (err?.response?.data?.error?.status == 0) {
                    navigate("/confirmation", {
                        state: {
                            msisdn,
                            pack,
                            extRef,
                            autoRenew
                        }
                    })
                }
                else if (err?.response?.data?.error?.status == 1) {
                    navigate("/low-balance");
                }
                else {
                    // toast.error(t("86"));

                    navigate("/confirmation", {
                        state: {
                            msisdn,
                            pack,
                            extRef,
                            autoRenew
                        }
                    })
                }
            });

        // navigate("/confirmation", {
        //     state: {
        //         msisdn,
        //         pack,
        //         extRef,
        //         autoRenew
        //     }
        // })

    }

    return (
        <>
            <Header />

            <div className={classes.container}>
                <h1 className={classes.heading}>
                    {t("147")}
                    <span style={{ color: '#3550dc' }}>Quiz Masters</span>{t("149")}
                </h1>
                <div className={classes.actions_box_container}>
                    <div className={classes.actions_box}>
                        <button className={`${classes.action_box}`}
                            type='button'
                            onClick={() =>
                                window.location.href = `/login?ext_id=${extRef}`
                                // navigate(`/login?ext_id=${extRef}`)
                            }>
                            {t("60")}
                        </button>
                        <button className={`${classes.action_box} ${classes.active}`}>
                            {t("61")}
                        </button>
                    </div>
                </div>


                <form className={classes.form}
                    onSubmit={handleSubscribe}
                >
                    <div className={classes.username_field_form}>
                        <div className={classes.country_code}>
                            <img src="/assets/images/cameroon.png" alt="flag" className={classes.flag} />
                            <p className={classes.country_code_number}>+237</p>
                        </div>
                        <input
                            id="msisdn"
                            name="msisdn"
                            type="number"
                            onWheel={(e) => e.target.blur()}
                            autoFocus placeholder={t("62")} className={classes.input_field_username}
                            onChange={(e) => {
                                setMsisdn(e.target.value)
                            }}
                            value={msisdn}
                        />
                    </div>

                    <div className={classes.packs}>
                        <p className={classes.packs_heading}>{t("63")}</p>

                        <button type='button' className={`${classes.pack_box} ${classes.shade_blue}`}
                            onClick={() => setPack("Daily")}
                        >
                            <span className={`${classes.pack_header} ${classes.shade_blue}`}>{t("119")}</span>
                            {
                                pack === "Daily" ?
                                    <div className={`${classes.checked_radio} ${pack === "Daily" && classes.shade_blue}`}>
                                        <FaCheck className={classes.checked_icon} />
                                    </div>
                                    : <div className={classes.dummy_radio}>

                                    </div>
                            }
                            <p className={`${classes.pack_price_point} ${classes.active}`}>
                                {t("130")}
                            </p>
                        </button>

                        <button type='button' className={`${classes.pack_box} ${classes.shade_green}`}
                            onClick={() => setPack("Weekly")}
                        >
                            <span className={`${classes.pack_header} ${classes.shade_green}`}>{t("120")}</span>
                            {
                                pack === "Weekly" ?
                                    <div className={`${classes.checked_radio} ${pack === "Weekly" && classes.shade_green}`}>
                                        <FaCheck className={classes.checked_icon} />
                                    </div>
                                    : <div className={classes.dummy_radio}>

                                    </div>
                            }
                            <p className={`${classes.pack_price_point} ${classes.active}`}>
                                {t("131")}
                            </p>
                        </button>

                        <button type='button' className={`${classes.pack_box} ${classes.shade_orange}`}
                            onClick={() => setPack("Monthly")}
                        >
                            <span className={`${classes.pack_header} ${classes.shade_orange}`}>{t("214")}</span>
                            {
                                pack === "Monthly" ?
                                    <div className={`${classes.checked_radio} ${pack === "Monthly" && classes.shade_orange}`}>
                                        <FaCheck className={classes.checked_icon} />
                                    </div>
                                    : <div className={classes.dummy_radio}>

                                    </div>
                            }
                            <p className={`${classes.pack_price_point} ${classes.active}`}>
                                {t("215")}
                            </p>
                        </button>

                    </div>

                    <div className={classes.check_box_container}>
                        <input type="checkbox" id="autorenew" name="Terms & Conditions" value="Terms"
                            className={classes.check_box} checked={autoRenew} onChange={(e) => setAutoRenew(e.target.checked)}
                        >
                        </input>
                        <label className={classes.check_box_label}>
                            <span className={classes.link} onClick={(e) => {
                                e.preventDefault();
                                e.stopPropagation();
                                setAutoRenewal(true)
                            }
                            }>{t("127")}</span>
                        </label>
                    </div>

                    <div className={classes.check_box_container}>
                        <input type="checkbox" id="terms" name="Terms & Conditions" value="Terms"
                            className={classes.check_box} checked={terms} onChange={(e) => setTerms(e.target.checked)}
                        >
                        </input>
                        <label for="terms" className={classes.check_box_label}>
                            {t("99")}{" "}<span className={classes.link} onClick={(e) => {
                                e.preventDefault();
                                e.stopPropagation();
                                setTermsModal(true)
                            }}>{t("114")}</span>
                        </label>
                    </div>

                    <button type="submit"
                        // id='cta_button'
                        disabled={!terms || loading || msisdn?.trim().length == 0}
                        className={classes.login_btn}>{
                            loading ? <SmallLoader style={{ border: "5px solid #fff" }} /> :
                                t("61")
                        }</button>
                    <div className={classes.footer}>
                        <p><span>&copy;</span> Rainboo Softmate {new Date().getFullYear()}</p>
                    </div>
                </form>

            </div>

            {termsModal && <TermsModal setTermsModal={setTermsModal} />}
            {autoRenewal && <AutoRenewalModal setAutoRenewal={setAutoRenewal} />}

        </>
    )
}

export default SubscriptionPage2